import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

const EditIcon = ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    height={`${size}`}
    width={`${size}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M14 3.414 18.586 8l-9 9H5v-4.586l9-9ZM4 21h16" />
    </g>
  </svg>
);

export default EditIcon;
